let domain = process.env.VUE_APP_DOMAIN;
let apiServer = process.env.VUE_APP_API_SERVER;
let baseQlw = process.env.VUE_APP_BASE_QLW;
let mobileServer = process.env.VUE_APP_MOBILE_SERVER;
let bigDataUrl = process.env.VUE_APP_BIGDATA;
let userCenter = process.env.VUE_APP_USERCENTER;
let registerUrl = process.env.VUE_APP_REGISTER;

//apiServer = "http://localhost:64590";
export default {
  base: apiServer,
  //文件服务器-头像
  nxinFileUrl: `https://files.${domain}/`,
  // 单点
  casTicket: `http://ucapi.${domain}/login/getLoginTicket`,
  loginApi: `https://cas.${domain}/cas/v1/tickets/loginApi`,
  casLogin: `https://cas.${domain}/cas/login.html`,
  //验证码
  validImg: `https://cas.${domain}/cas/captchaCode.htm`,
  //单点退出
  signout: `https://cas.${domain}/cas/logout`,
  editInfo: `http://wo.${domain}/edit`,
  entInfo: `http://wo.${domain}/ent`,
  helpUrl: `http://help.${domain}`,
  ylwUrl: `http://ylw.${domain}`,
  // PC质量追溯
  pcQuantityUrl: `http://ylwgl.${domain}/backEnd`,
  // 质量追溯
  quantityUrl: `http://ylwgl.${domain}`,
  //圈子
  circle: `http://chat.i.${domain}/api/`,
  // 商品设置地址
  epmUrl: `https://epmc.${domain}`,
  // 企联网
  oaUrl: `http://qlw.${domain}`,
  // 角色权限管理
  baseUrl: baseQlw,
  // 商城
  scUrl: `https://sc.${domain}`,
  smartDevice: `http://ylwzn.${domain}/`,
  // 企业大数据
  enterpriseBigData: bigDataUrl,
  // 用户中心
  center: userCenter,
  // 质量追溯 图片上传
  imgUpload: apiServer + "/api/Resource",
  // 质量追溯二维码跳转
  mobileServer: mobileServer,
  registerUrl: registerUrl,
};
